export const ActionTypes = {
  CITATION_LOAD: 'CITATION/LOAD',
  CITATION_REVIEW: 'CITATION/REVIEW',
  CITATION_UPDATE: 'CITATION/UPDATE',
  CITATION_UPDATE_SUCCEEDED: 'CITATION/UPDATE_SUCCEEDED',
  CITATION_UPDATE_FAILED: 'CITATION/UPDATE_FAILED',
  CITATION_CREATE: 'CITATION/CREATE',
  CITATION_CREATE_SUCCEEDED: 'CITATION/CREATE_SUCCEEDED',
  CITATION_CREATE_IN_PROGRESS: 'CITATION/CREATE_IN_PROGRESS',
  CITATION_CREATE_GTM: 'CITATION/CREATE_GTM',
  CITATION_CREATE_FAILED: 'CITATION/CREATE_FAILED',
  CITATION_VALIDATED: 'CITATION/VALIDATED',
  IGNORE_INCOMPLETE_CITATION: 'CITATION/IGNORE_INCOMPLETE_CITATION',
  SOURCE_SEARCHED: 'SOURCE_SEARCHED',
  ADD_AUTOCITE_METADATA: 'ADD_AUTOCITE_METADATA',
  SHOW_ERROR_TOAST: 'SHOW_ERROR_TOAST',
} as const

export const ValidatorStates = {
  COMPLETE: 'complete',
  MISSING: 'missing',
  IGNORED: 'ignored',
} as const
